<template>
  <div class="national-box">
    <div class="national-item"
         v-for="(i, index) in nationList" :key="index"
         @click="handleClickItem(i,index)"
         :class="current === index ? 'national-active' : i.style">

      <img class="country-img" :src="i.icon | filterImg(api)" />
      <span v-if="showText">{{i.value}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "NationList",
  props: {
    list: { // 传入语言数组
      type: Array,
      default() {
        return []
      }
    },
    highLight: { // 高亮列表
      type: Array,
      default() {
        return []
      }
    },
    disabled: { // 禁止点击
      type: Boolean,
      default: false,
    },

    showText: { // 是否显示文字
      type: Boolean,
      default: true,
    },

    lang: { // 主语言
      type: String,
      default: ""
    }
  },
  data() {
    return {
      current: 0,
      api: this.$api.$base.root,
      firstSetCurrent: true,
      firstSetLang: true,
    }
  },
  computed: {
    // 格式化传入语言列表
    formatList() {
      let list = this.list.length ? this.handleFormatList() : this.handleLoadSysLang();
      return list;
    },

    nationList() {
      let list = this.formatList.map(item => {
        return {
          ...item,
          style: this.highLight.includes(item.value) ? "national-distinct" : "national-default"
        };
      })
      if(this.lang) {
        // lang 主语言放置list 第0 位
        let index = list.findIndex(item => item.value === this.lang);
        if(index > 0) list.unshift(...list.splice(index,1));
        return list;
      }
      return list;
    }
  },
  methods: {
    // 根据语言设置索引
    handleSetCurrentByLang(lang) {
      if(this.disabled || !this.nationList.length) return;
      let index = this.nationList.findIndex(item => item.value === lang);
      if(index !== -1 && index !== this.current) {
        this.current = index;
      }
    },

    //点击
    handleClickItem(item,index) {
      if(this.disabled) return;
      this.current = index;
      this.$emit('click', item);
    },

    // 设置索引
    handleSetCurrent(index) {
      this.$nextTick(() => {
        this.current = index;
        this.$emit('click', this.nationList[0]);
      })
    },

    // 格式化外部传入的list
    handleFormatList() {
      let supportLangList = this.$store.state.supportLangList;
      return supportLangList.filter(item =>  this.list.includes(item.value))
    },

    // 系统语言
    handleLoadSysLang() {
      let sysLang = this.$store.state.sysSetLang;
      let supportLangList = this.$store.state.supportLangList;
      if(sysLang.length) {
        return supportLangList.filter(i =>  sysLang.includes(i.value));
      }
      return supportLangList;
    },
  },
  watch:{
    disabled: {
      handler() {
        if(this.firstSetCurrent) {
          this.current = this.disabled ? null : 0;
          this.firstSetCurrent = false;
        }
      },
      deep: true,
      immediate: true,
    },
    nationList: {
      handler(list) {
        if(list.length && this.firstSetLang) {
          this.$emit("click",  list[this.current]);
          this.firstSetLang = false;
        }

        // 判断current 大于 列表长度自动设置回到0
        if(this.current >= list.length) {
          this.handleSetCurrent(0);
        }
      },
      immediate: true,
      deep: true,
    },
    formatList: {
      handler(list) {
        let val = list.map(i => i.value);
        this.$emit("onList", val);
      },
      deep: true,
      immediate: true,
    },
    lang: {
      handler(val) {
        if(val) {
          this.handleClickItem(this.nationList[0], 0);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  filters: {
    filterImg(code, api) {
      let img = api + code;
      return img;
    }
  },
}
</script>

<style scoped>


.national-box {
  display: flex;
  flex-wrap: wrap;
  column-gap: 14px;
  row-gap: 6px;
}

.national-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
}


.country-img {
  width: 34px;
  height: 20px;
  border: 2px solid #dddddd;
}


.national-active {
  color: #f4b965;
}

.national-active .country-img {
  border: 2px solid #f4b965;
}

.national-default {
  cursor: default;
}

.national-default .country-img {
  opacity: 0.3;
}

.national-distinct {
  cursor: default;
}

.national-distinct .country-img {
  opacity: 1;
}

</style>
